import serverApi from "../utils/serverApi";

const eventService = {
    getActiveEvent: () => serverApi({ uri: `events/active`, method: "GET", isLoading: false }),
    getEventDetail: (uuid, isLoading = true) => serverApi({ uri: `events/${uuid}`, method: "GET", isLoading }),
};

export default eventService;
